<template>
  <div>
    <div class="box1">
      <p class="tishixinxi">您有一个新的来电，请及时处理！！！</p>
    </div>
    <div class="bigBox">
      <div v-show="!this.knowedgeQeck" class="workcenter">
        <Card dis-hover class="sum-card-box2">
          <div class="center-01">
            <h3>我猜您想解决以下问题：</h3>
            <div @click="tiaozhaun(2)">
              <Icon type="md-add" size="20" />
            </div>
          </div>
          <div class="center-02">
            <div>
              <Input
                v-model="descr"
                placeholder="请输入关键词"
                clearable
                @on-change="Search1(descr)"
                icon="ios-search"
              />
            </div>
            <div class="center-03">
              <Table
                :columns="columns"
                :data="data"
                stripe
                highlight-row
                @on-row-click="rowClick"
              ></Table>
            </div>
          </div>
        </Card>
      </div>
      <div v-show="this.knowedgeQeck" class="workcenter">
        <Card dis-hover class="sum-card-box2">
          <div class="center-01">
            <h3>工单处理常用语：</h3>
            <div @click="tiaozhaun(2)">
              <Icon type="md-add" size="20" />
            </div>
          </div>
          <div class="center-02">
            <div>
              <Input
                v-model="descr2"
                placeholder="请输入关键词"
                clearable
                @on-change="Search2(descr2)"
                icon="ios-search"
              />
            </div>
            <div class="center-03">
              <Table
                :columns="columns2"
                :data="data2"
                stripe
                highlight-row
                @on-row-click="rowClick2"
              ></Table>
            </div>
          </div>
        </Card>
      </div>
      <div class="workleft">
        <div class="radio-work">
          <el-radio-group size="mini" @input="changeCall" v-model="radio1">
            <el-radio-button label="需要派单"></el-radio-button>
            <el-radio-button label="不需要派单"></el-radio-button>
          </el-radio-group>
        </div>
        <Form
          ref="form"
          :model="forms"
          :label-width="150"
          :disabled="action == 'view' ? true : false"
        >
          <div v-show="!this.knowedgeQeck" class="workleft-0">
            <p>问题描述:</p>
            <div class="left-01">
              <Icon
                v-show="getText"
                type="ios-close-circle"
                color="#5c6b77"
                @click="clearGetText()"
                class="clear_icon"
                size="16"
              />
              <Input
                v-model="getText"
                type="textarea"
                placeholder="请输入或点击左侧选择"
              ></Input>
            </div>
            <div class="left-02">{{ programme }}</div>
          </div>
          <div v-show="this.knowedgeQeck" class="workleft-0">
            <p>处理内容:</p>
            <div class="left-01">
              <Input
                v-model="maintainerContent"
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 3 }"
                placeholder="请输入或点击左侧选择"
              ></Input>
            </div>
          </div>
          <div v-show="this.knowedgeQeck" class="workleft-0">
            <p>故障原因:</p>
            <div class="left-01">
              <Select
                class="Select"
                v-model="teackRemark"
                filterable
                placeholder="请选择故障原因"
                clearable="true"
              >
                <Option
                  v-for="item in teackList"
                  :value="item.id"
                  :key="item.id"
                  >{{ item.descr }}
                </Option>
              </Select>
            </div>
          </div>
          <div class="first-line">
            <div>
              <p><span style="color: red">*</span> 科室信息:</p>
              <el-select
                v-model="DepartmentValue"
                class="Select"
                filterable
                remote
                reserve-keyword
                placeholder="请选择或搜索科室"
                :remote-method="remoteMethod1"
                @change="OnDepartment(DepartmentValue)"
                :loading="loading1"
              >
                <el-option
                  v-for="item in deskList"
                  :key="item.id"
                  :label="item.deskName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              <!--              <Select class="Select" v-model="DepartmentValue" filterable placeholder="请选择或搜索科室" :remote-method="remoteMethod1"-->
              <!--                      :loading="loading1" clearable="true"-->
              <!--                      @on-query-change = "onQueryC"-->
              <!--                @on-change="OnDepartment(DepartmentValue)">-->
              <!--                <Option v-for="item in deskList" :value="item.id" :key="item">{{ item.deskName }}-->
              <!--                </Option>-->
              <!--              </Select>-->
            </div>
            <div>
              <p>设备信息:</p>
              <el-select
                class="Select"
                v-model="EquipmentValue"
                filterable
                remote
                reserve-keyword
                :remote-method="remoteMethod2"
                placeholder="请选择或搜索设备信息"
                clearable="true"
                :loading="loading2"
                @change="SelectEquipment(EquipmentValue)"
              >
                <el-option
                  v-for="item in EquipmentList"
                  :value="item.Num"
                  :key="item.id"
                  :label="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="first-line">
            <div>
              <p style="display: inline"></p>
              <Input
                class="Select"
                v-model="RepairText"
                placeholder="请选择科室"
                disabled
              ></Input>
            </div>
            <div>
              <p>房间号:</p>
              <Input
                class="Select"
                v-model="room"
                placeholder="请输入房间号"
              ></Input>
            </div>
          </div>
          <div class="first-line">
            <div>
              <p><span style="color: red">*</span>故障类型:</p>
              <Select
                class="Select"
                v-model="typeId"
                filterable
                placeholder="请选择问题或故障类型"
                @on-change="changeTypeId(typeId)"
              >
                <Option
                  v-for="item in workList"
                  :value="item.typeId"
                  :key="item.typeId"
                  >{{ item.name }}
                </Option>
              </Select>
            </div>
            <div style="flex-direction: column">
              <div>
                <p>重点科室:</p>

                <Select
                  class="Select"
                  v-model="isImportant"
                  placeholder="请选择是或否"
                  @on-change="changeIsImportant(isImportant)"
                >
                  <Option label="否" :value="2"> </Option>
                  <Option label="是" :value="1"> </Option>
                </Select>
              </div>
              <div>
                <span class="zhongdain" v-show="block"
                  >重点科室，请注意沟通！</span
                >
              </div>
            </div>
          </div>
          <div class="first-line">
            <div>
              <p style="display: inline">报修人:</p>
              <Input
                class="Select"
                v-model="repairBy"
                placeholder="请输入报修人"
              ></Input>
            </div>
            <div>
              <p>来电电话:</p>
              <Input
                class="Select"
                v-model="repairPhone"
                placeholder="请输入来电电话"
              ></Input>
            </div>
          </div>

          <!--          <form-body-->
          <!--            :forms="forms"-->
          <!--            :items="items"-->
          <!--            :disabled="action == 'view' ? true : false"-->
          <!--          ></form-body>-->
          <div v-show="!this.knowedgeQeck" class="workleft-1">
            <div class="workleft-11">
              <p>派单类型:</p>
              <RadioGroup
                v-model="sendType"
                @on-change="changeOrderType(sendType)"
                class="RadioGroup"
              >
                <Radio :label="2">自动派单</Radio>
                <Radio :label="1">手动派单</Radio>
                <Radio :label="3">抢单派单</Radio>
              </RadioGroup>
              <Select
                class="left-12-Select"
                v-model="engineer1"
                placeholder="请选择维修员"
                clearable="true"
                @on-change="Selectengineer2(engineer1)"
                filterable
                v-show="single == false ? true : false"
              >
                <Option
                  v-for="item in engineerList2"
                  :value="item.nickName"
                  :key="item.userId"
                  >{{ item.nickName }}
                </Option>
              </Select>
            </div>
          </div>
          <div v-show="this.knowedgeQeck" class="service-line">
            <div>
              <p><span style="color: red">*</span> 服务类型:</p>
              <Select
                class="Select"
                v-model="service"
                filterable
                placeholder="请选择服务类型"
                clearable="true"
              >
                <Option
                  v-for="item in serviceList"
                  :value="item.service"
                  :key="item.service"
                  >{{ item.service }}
                </Option>
              </Select>
            </div>
          </div>
          <div v-show="this.knowedgeQeck" class="compare-line">
            <div>
              <p style="display: inline">处理状态:</p>
              <Input class="Select" v-model="state" disabled></Input>
            </div>
          </div>
          <div v-show="!this.knowedgeQeck" class="workleft-2">
            <Button
              type="info"
              @click="handleSubmit"
              size="default"
              class="button2"
              >保 存
            </Button>
          </div>
          <div v-show="this.knowedgeQeck" class="workleft-3">
            <Button
              type="info"
              @click="handleSubmit"
              size="default"
              class="button2"
              >保 存
            </Button>
          </div>
          <div v-show="this.knowedgeQeck" class="workleft-4">
            <Button
              type="info"
              @click="handleSubmitKnow"
              size="default"
              class="button2"
              >保存并转存知识库
            </Button>
          </div>
          <!--              <button-box v-show="this.knowedgeQeck" class="workleftCompare" v-if="action != 'view'">-->
          <!--                <Poptip-->
          <!--                    confirm-->
          <!--                    title="请检查数据, 再确认提交"-->
          <!--                    @on-ok="handleSubmit"-->
          <!--                >-->
          <!--                  <button-sub class="submit" :loading="sloading">保存</button-sub>-->
          <!--                </Poptip>-->
          <!--                  <button-->
          <!--                      v-if="this.knowedgeQeck"-->
          <!--                      @click="handleSubmitKnow"-->
          <!--                      class="knowledge"-->
          <!--                  >-->
          <!--                    保存并转存知识库-->
          <!--                  </button>-->

          <!--                <button-back></button-back>-->
          <!--              </button-box>-->
        </Form>
      </div>
    </div>
  </div>
</template>
<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import Change from "@/views/workOrder/question.vue";
import log from "@/api/modules/log";

export default {
  extends: baseEdit,
  components: { change: Change },
  props: {
    id: {
      type: String,
      value: "",
    },
    deskId: {
      type: String,
      value: "",
    },
    phone: {
      type: String,
      value: "",
    },
    callId: {
      type: String,
      value: "",
    },
    typeId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      data: [],
      data2: [],
      descr: "",
      allData: [],
      serviceList: [
        {
          service: "服务类",
          lable: "服务类",
        },
        {
          service: "换修类",
          lable: "换修类",
        },
        {
          service: "新增类",
          lable: "新增类",
        },
      ],
      service: "服务类",
      isImportant: 2,
      descr2: "",
      allData2: [],
      radio1: "需要派单",
      DepartmentValue: null,
      EquipmentValue: "",
      color1: true,
      sendType: 2, //派单类型
      single: true,
      getText: "",
      maintainerContent: "",
      programme: "",
      EquipmentList: {}, //设备列表
      workList: {},
      engineerList2: {},
      maintainerId: "",
      engineer1: "",
      repairPhone: "",
      repairBy: "",
      color2: false,
      mname: "work",
      teackRemark: "",
      deskList: [], //科室列表
      teackList: [], //故障原因列表
      RepairText: "",
      room: "",
      state: "已完成",
      key: "id",
      columns: [
        {
          title: "问题描述",
          minWidth: 170,
          align: "left",
          key: "descr",
        },
      ],
      columns2: [
        {
          title: "处理内容",
          minWidth: 170,
          align: "left",
          key: "descr2",
        },
      ],
      knowedgeQeck: false,
      url: {},
      block: false,
      loading1: false,
      loading2: false,
    };
  },
  computed: {
    extRender() {
      return ["change"];
    },
  },
  mounted() {},
  async created() {
    this.DepartmentValue = this.deskId;
    await this.Department(this.DepartmentValue);
    await this.OnDepartment(this.DepartmentValue);
    await this.loadfaultData();
    this.changeOrderType(2);
    this.repairPhone = this.phone;
    await this.loadTypeData();
    await this.deskListMethod();
    await this.loadWorkCommon();
    this.loadCommonData2();
    this.loadCommonData();
    // this.loadworkData();
  },
  methods: {
    async remoteMethod1(query) {
      let d = {};
      this.loading1 = true;
      if (query !== "") {
        d.deskName = query;
      }
      console.log(query);
      let res = await $utils.api.load(
        "/admin/system/desk/selectList",
        d,
        "get"
      );
      if (res && res.rows) {
        this.loading1 = false;
        this.deskList = res.rows;
        console.log(this.deskList);
      } else {
        this.loading1 = false;
      }
    },

    async remoteMethod2(query) {
      let d = {};
      this.loading2 = true;
      if (query !== "") {
        d.facilityName = query;
      }
      let res = await $utils.api.load(
        "/admin/system/facility/selectListSearch",
        d,
        "get"
      );
      if (res && res.rows) {
        this.loading2 = false;
        let list = res.rows;
        let arr = [];
        if (list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            let item = list[i];
            let obj = {};
            obj.deskId = item.deskId;
            obj.value =
              item.assetNum + "_" + item.facilityName + "_" + item.facilityType;
            obj.Num = item.facilityNum;
            arr.push(obj);
          }
        }
        this.EquipmentList = arr;
      } else {
        this.loading2 = false;
      }
    },

    clearGetText() {
      this.getText = "";
      this.programme = "";
    },
    //选择维修员
    Selectengineer2(item) {
      if (this.engineerList2.length > 0) {
        for (let i = 0; i < this.engineerList2.length; i++) {
          let a = this.engineerList2[i];
          if (a.nickName == item) {
            this.maintainerId = a.userId;
          }
        }
      }
    },

    //选择设备
    async SelectEquipment(item) {
      let list = this.EquipmentList;

      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let a = list[i];
          if (!item) {
            await this.loadCommonData(null);
          }
          if (a.Num == item) {
            this.facilityNo = a.Num;
            this.DepartmentValue = a.deskId;
            await this.Department(this.DepartmentValue);
            await this.loadfaultData(this.facilityNo);
          }
        }
      }
    },
    changeIsImportant(isImportant) {
      if (isImportant == 1) {
        this.block = true;
      } else {
        this.block = false;
      }
    },
    //选择设备
    async loadfaultData(facilityNo) {
      if (facilityNo) {
        let q = {};

        q.facilityNum = facilityNo;
        let res = await $utils.api.load(
          `/admin/system/facility/workTypeHome`,
          q
        );
        console.log(4444, res);
        if (res) {
          let list = res.rows;
          if (!list || list.length === 0) {
            this.workList = {};
            this.typeId = "";
            this.getText = "";
          } else {
            await this.loadCommonData(list[0].id);
            this.typeId = list[0].id;
            await this.changeTypeId(this.typeId);
            await this.loadTypeData();
          }
        }
      }
    },
    //派单类型
    changeOrderType(item) {
      if (item == 1) {
        this.single = false;
      } else {
        this.single = true;
      }
    },
    changeCall() {
      if (this.radio1 == "需要派单") {
        this.knowedgeQeck = false;
      } else {
        this.knowedgeQeck = true;
      }
    },
    //常用语跳转
    tiaozhaun(item) {
      console.log(item);
      this.$Modal.remove();
      if (item == 1) {
        $utils.url.push({
          name: "worktype_list",
        });
      } else if (item == 2) {
        $utils.url.push({
          name: "commondescr_add",
        });
      }
    },
    Search1(descr) {
      let keyword = this.descr;
      let allData = this.allData;
      let newData = [];
      for (let index = 0; index < allData.length; index++) {
        let item = allData[index] || {};
        let descrOld = item.descr;
        if (descrOld.indexOf(keyword) != -1) {
          newData.push(item);
          this.data = newData;
        }
      }
    },
    Search2(descr2) {
      let keyword = this.descr2;
      let allData = this.allData2;
      let newData = [];
      for (let index = 0; index < allData.length; index++) {
        let item = allData[index] || {};
        let descrOld = item.descr2;
        if (descrOld.indexOf(keyword) != -1) {
          newData.push(item);
          this.data2 = newData;
        }
      }
    },
    async loadCommonData(id) {
      let q = {};
      q.workTypeId = id;
      q.workType = 1;
      let res = await $utils.api.load(
        "/admin/system/common/noPageCommonList",
        q
      );
      if (res) {
        if (res.code > 0) {
          let list = res.rows || [];

          this.allData = list;
          this.data = list;
        }
      }
    },
    async loadCommonData2() {
      let q = {};
      q.workType = 2;
      let res = await $utils.api.load("/admin/system/common/noPageList", q);
      if (res.code > 0) {
        console.log(7878787, res);
        let list = res.rows || [];
        let arr = [];
        if (list && list.length > 0) {
          for (let i = 0; i < list.length; i++) {
            let item = list[i];
            let obj = {};
            (obj.descr2 = item.descr), arr.push(obj);
          }
        }

        this.allData2 = arr;
        this.data2 = arr;
      }
    },
    async rowClick(row) {
      // 点击选择行

      let descr = row.descr;
      console.log(row.recommendation);
      this.getText = descr;
      await this.loadData(row.id);
      if (row.recommendation != "") {
        this.programme = row.recommendation;
      } else {
        this.programme = "暂无处理方案";
      }
    },
    async rowClick2(row) {
      // 点击选择行

      let descr = row.descr2;
      this.maintainerContent = descr;
    },
    async loadData(id) {
      let q = {};
      q.id = id;
      let res = await $utils.api.load("/admin/system/common/pageList", q);
      if (res) {
        if (res.code > 0) {
          this.typeId = res.data.id;
          this.changeTypeId(this.typeId); //查询维修员
        }
      }
    },
    async OnDepartment(deskId) {
      console.log(1111);
      if (this.deskId) {
        this.EquipmentList = [];
        this.EquipmentValue = "";
      }
      this.deskId = deskId;
      await this.Department(deskId);
      let q = {};
      q.state = 2;
      q.deskId = deskId;
      let res = await $utils.api.load(
        "/admin/system/facility/selectListSearch",
        q,
        "get"
      );
      let list = res.rows;
      let arr = [];
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let item = list[i];
          console.log(item);
          let obj = {};
          obj.deskId = item.deskId;
          obj.value =
            item.assetNum + "_" + item.facilityName + "_" + item.facilityType;
          obj.Num = item.facilityNum;
          arr.push(obj);
        }
      } else {
        this.EquipmentValue = "";
      }
      this.EquipmentList = arr;
    },
    //选择故障类型下拉框
    async loadTypeData() {
      let q = {};
      q.typeId = this.typeId;
      // 通过pk查询字典数据
      let res = await $utils.api.load("/admin/system/workType/listFrame", q);
      console.log(111, res);
      if (res && res.rows) {
        let list = res.rows;
        if (list.length > 0) {
          let lists = [];
          list.forEach((obj) => {
            lists.push({ name: obj.name, typeId: obj.id });
            if (obj.deskList && obj.deskList.length > 0) {
              obj.deskList.forEach((item) => {
                const newObj = {
                  name: `${obj.name}-${item.name}`,
                  typeId: item.id,
                };
                lists.push(newObj);
              });
            }
          });
          console.log("workTypeList", lists);
          this.workList = lists;
        }
      }
    },
    async Department(id) {
      if (id == undefined) {
        return;
      } else {
        let res = await $utils.api.load(`/admin/system/desk/${id}`);
        if (res.code === 200) {
          if (res.data) {
            if (res.data.isImportant == 1) {
              this.block = true;
              this.isImportant = 1;
            } else {
              this.block = false;
              this.isImportant = 2;
            }
            let workInfotemp = "";
            if (
              res.data.principal !== null &&
              res.data.principal !== undefined
            ) {
              workInfotemp = res.data.principal;
            }
            if (res.data.address !== null && res.data.address !== "") {
              workInfotemp = workInfotemp + "/" + res.data.address;
            }
            this.RepairText = workInfotemp;
          }
        }
      }
    },
    async deskListMethod() {
      console.log(1111111);
      let res = await $utils.api.load("/admin/system/desk/selectList");
      if (res && res.rows) {
        this.deskList = res.rows;
      }
    },
    async loadWorkCommon() {
      // 通过pk查询字典数据
      let q = {};
      q.workType = 3;
      let res = await $utils.api.load("/admin/system/common/typeList", q);
      if (res && res.rows) {
        this.teackList = res.rows;
      }
    },
    async changeTypeId(typeId) {
      if (typeId) {
        // this.loadChildData(typeParentId);
        // 通过pk查询字典数据
        let res = await $utils.api.load(`/admin/system/maiUser/type/${typeId}`);
        if (res && res.rows) {
          this.engineerList2 = res.rows;
        }
      }
    },

    handleSubmitKnow() {
      if (this.knowedgeQeck) {
        if (!this.maintainerContent) {
          $utils.toast.error("请填写处理内容");
          return;
        }
        if (!this.service) {
          $utils.toast.error("请填写服务类型");
          return;
        }
      } else {
        if (!this.getText) {
          $utils.toast.error("请填写问题描述");
          return;
        }
      }

      if (!this.DepartmentValue) {
        $utils.toast.error("请选择科室");
        return;
      }
      if (!this.typeId) {
        $utils.toast.error("请选择故障类型");
        return;
      }
      if (this.sendType == 1) {
        if (!this.maintainerId) {
          $utils.toast.error("请选择维修员");
          return;
        }
      }
      let q = {
        descr: this.getText,
        deskId: this.DepartmentValue,
        facilityNo: this.EquipmentValue,
        typeId: this.typeId,
        repairBy: this.repairBy,
        repairPhone: this.repairPhone,
        sendType: this.sendType,
        maintainerId: this.maintainerId,
        isKnow: 1,
        maintainType: 2,
        callId: this.callId,
        maintainerContent: this.maintainerContent,
        teackRemark: this.teackRemark,
        service: this.service,
        repairSource: 4,
        isImportant: this.isImportant,
      };
      if (this.EquipmentValue) {
        q.isFastOrder = 0;
      } else {
        q.isFastOrder = 1;
      }

      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;

          $utils.api
            .load(
              `/admin/system/work/callCenterAdd`,
              q,
              this.action == "edit" ? "PUT" : "POST"
            )
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                this.$Modal.remove();
                setTimeout(() => {
                  $utils.url.go(0);
                }, 1000);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    handleSubmit() {
      if (this.knowedgeQeck) {
        if (!this.maintainerContent) {
          $utils.toast.error("请填写处理内容");
          return;
        }
        if (!this.service) {
          $utils.toast.error("请填写服务类型");
          return;
        }
      } else {
        if (!this.getText) {
          $utils.toast.error("请填写问题描述");
          return;
        }
      }

      if (!this.DepartmentValue) {
        $utils.toast.error("请选择科室");
        return;
      }
      if (!this.typeId) {
        $utils.toast.error("请选择故障类型");
        return;
      }
      if (this.sendType == 1) {
        if (!this.maintainerId) {
          $utils.toast.error("请选择维修员");
          return;
        }
      }
      let q = {
        descr: this.getText,
        deskId: this.DepartmentValue,
        facilityNo: this.EquipmentValue,
        typeId: this.typeId,
        repairBy: this.repairBy,
        repairPhone: this.repairPhone,
        sendType: this.sendType,
        maintainerId: this.maintainerId,
        isKnow: 0,
        maintainType: 2,
        callId: this.callId,
        maintainerContent: this.maintainerContent,
        teackRemark: this.teackRemark,
        service: this.service,
        repairSource: 4,
        isImportant: this.isImportant,
        facilitySite: this.room,
      };
      if (this.EquipmentValue) {
        q.isFastOrder = 0;
      } else {
        q.isFastOrder = 1;
      }

      if (this.knowedgeQeck) {
        q.state = 3;
      } else {
        q.state = 1;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/work/callCenterAdd`, q, "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
              }
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 1000);
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
              this.$Modal.remove();
              setTimeout(() => {
                $utils.url.go(0);
              }, 2000);
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bigBox {
  height: calc(667px);
  margin-top: 17px;
  display: flex;
  justify-content: space-between;

  .workleft {
    width: 90%;
    margin-left: 1%;

    .radio-work {
      margin-left: 100px;
    }

    h3 {
      margin-bottom: 10px;
    }

    .first-line {
      margin-top: calc(20px);
      width: calc(94%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .zhongdain {
          font-size: 20px;
          color: red;
          font-weight: 700;
          vertical-align: middle;
        }

        .Select {
          width: 85%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .el-input__inner {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: 1px solid #dcdee2;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }

          /deep/ .ivu-select-input {
            display: inline-block;
            height: 32px;
            line-height: 32px;
            padding: 0 24px 0 8px;
            font-size: 14px;
            outline: none;
            border: none;
            box-sizing: border-box;
            color: #3871f1;
            background-color: transparent;
            position: relative;
            cursor: pointer;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 21%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .compare-line {
      margin-top: calc(10px);
      width: calc(85.3%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .Select {
          width: 43%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 10%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .service-line {
      margin-top: calc(160px);
      width: calc(88%);
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;

      div {
        display: flex;
        justify-content: flex-start;
        width: 100%;

        .Select {
          width: 41%;
          display: inline-block;
          margin-right: 10px;

          /deep/ .ivu-input[disabled] {
            background-color: #f3f3f3;
            opacity: 1;
            cursor: not-allowed;
            color: #3871f1;
          }
        }

        p {
          color: #00050e;
          font-size: 0.875rem;
          padding-top: 5px;
          text-align: left;
          width: 10%;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .workleft-0 {
      margin-top: 15px;
      width: calc(94%);

      p {
        color: #00050e;
        font-size: 0.875rem;
        width: 9.5%;
        display: inline-block;
      }

      .left-01 {
        display: inline-block;
        width: calc(90.5% - 10px);

        vertical-align: top;
        position: relative;

        .clear_icon {
          position: absolute;
          right: 10px;
          top: 50%;
          transform: translateY(-50%);
          z-index: 2;
        }

        /deep/ .ivu-input {
          display: inline-block;
          width: 100%;
          // height: calc(25%);
          // line-height: 1.5;
          padding: 4px 7px;
          font-size: 14px;
          border: 1px solid #dcdee2;
          border-radius: 4px;
          color: #3871f1;
          background-color: #fff;
          background-image: none;
          position: relative;
          cursor: text;
          transition: border 0.2s ease-in-out, background 0.2s ease-in-out,
            box-shadow 0.2s ease-in-out;
        }
      }

      .left-02 {
        width: calc(90.5% - 10px);
        border-radius: 5px;
        background-color: #f3f3f3;
        border: 1px rgb(220, 222, 226) solid;
        height: 200px;
        color: #ee0000;
        margin-top: 20px;
        margin-left: 9.5%;
        overflow: scroll;
      }
    }

    .workleft-1 {
      height: 33px;
      margin-top: 60px;
      width: 100%;

      .workleft-11 {
        font-size: 12px;
        display: flex;

        .RadioGroup {
          color: #00050e;
          margin-top: 4px;
          width: 40%;
        }

        .left-12-Select {
          width: 30%;
          display: inline-block;
        }

        p {
          color: #00050e;
          width: 8%;
          margin-right: calc(20px);
          padding-top: 5px;
          font-size: 14px;
        }
      }
    }

    .workleft-2 {
      position: absolute;
      width: 800px;
      bottom: 15px;

      .button2 {
        width: 100%;
      }
    }

    .workleft-3 {
      position: absolute;
      width: 397px;
      bottom: 15px;

      .button2 {
        width: 100%;
      }
    }

    .workleft-4 {
      position: absolute;
      margin-left: 400px;
      width: 399px;
      bottom: 15px;

      .button2 {
        width: 100%;
      }
    }

    .workleftCompare {
      margin-top: calc(10px);

      .knowledge {
        margin: 10px 5px 5px 120px;
        width: 125px;
        height: 32px;
        background-color: #1890ff;
        color: #f6f8f7;
        border: none;
        border-radius: 5px;
      }

      .submit {
        margin: 10px 5px 5px 5px;
        width: 80px;
        height: 32px;
        background-color: #1890ff;
        color: #f6f8f7;
        border: none;
        border-radius: 5px;
      }
    }
  }

  .workcenter {
    width: 30%;
    height: 100%;

    i {
      cursor: pointer;
    }

    .center-01 {
      color: #00050e;
      width: 100%;
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }

    .center-02 {
      height: 580px;

      .center-03 {
        height: 100%;
        overflow: auto;
        width: 300px;

        /deep/ .ivu-table {
          width: inherit;
          height: 100%;
          max-width: 100%;
          overflow: hidden;
          color: #3871f1;
          font-size: 14px;
          background-color: #fff;
          box-sizing: border-box;
        }
      }
    }
  }
}

.sum-card-box2 {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: #f9f9f9;

  .ivu-card-body {
    height: 100%;
  }

  .header_box {
    h3 {
      padding-top: 10px;
      margin-left: 15px;
    }
  }

  .item3 {
    height: 0px;
    margin-bottom: 2px;
    width: 100%;
  }

  .item4 {
    border-top: 1px solid #e8e8e8;
    padding-top: 5px;
    margin-top: 8px;
    font-size: 14px;
    line-height: 22px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    span:last-child {
      margin-left: 8px;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}

.logo {
  display: block;
  width: 60px;
}

.btn1 {
  background-color: rgb(232, 244, 255) !important;
  border-radius: 5px;
  color: #1890ff !important;
  cursor: pointer;
  border: 1px solid #1890ff;
}

.btn2 {
  background-color: rgba(128, 128, 128, 0.432) !important;
  border-radius: 5px;
  // color: white !important;
  cursor: pointer;
  border: 1px solid gray;
}

.workcolor {
  margin: 5px 5px 5px 150px;
  width: 80px;
  height: 30px;
}

.box1 {
  width: 1200px;
  height: 65px;
  position: relative;
  left: -32px;
  top: -22px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  animation: Glow 0.6s ease infinite alternate;
  -webkit-animation: Glow 0.6s ease infinite alternate; //兼容Chrome
}

.tishixinxi {
  font-size: 30px;
  color: white;
  border: none;
  position: absolute;
  top: 10px;
  left: 28%;
  // text-shadow: 0 0 10px #e5ce44, 0 0 2px #e5ce44, 0 0 20px #e5ce44,
  //   0 0 20px #e5ce44;
  // -webkit-animation: Glow 0.5s ease infinite alternate; //兼容Chrome
}

@keyframes Glow {
  0% {
    // bor
    background-color: #00bfff;
  }

  10% {
    background-color: #00bfff;
  }

  20% {
    background-color: #00bfff;
  }

  30% {
    background-color: #c1c1c1;
  }

  40% {
    background-color: #c1c1c1;
  }

  50% {
    background-color: #c1c1c1;
  }

  60% {
    background-color: #00bfff;
  }

  70% {
    background-color: #00bfff;
  }

  80% {
    background-color: #c1c1c1;
  }

  90% {
    background-color: #c1c1c1;
  }

  100% {
    background-color: #c1c1c1;
  }
}
@-webkit-keyframes Glow {
  0% {
    // bor
    background-color: #00bfff;
  }

  10% {
    background-color: #00bfff;
  }

  20% {
    background-color: #00bfff;
  }

  30% {
    background-color: #c1c1c1;
  }

  40% {
    background-color: #c1c1c1;
  }

  50% {
    background-color: #c1c1c1;
  }

  60% {
    background-color: #00bfff;
  }

  70% {
    background-color: #00bfff;
  }

  80% {
    background-color: #c1c1c1;
  }

  90% {
    background-color: #c1c1c1;
  }

  100% {
    background-color: #c1c1c1;
  }
}

.completecolor {
  width: 80px;
  height: 30px;
  margin: 5px 5px 5px 30px;
}
</style>
